<template>
  <div class="sshx">
    <div class="container">
      <div class="banner">
        <div class="auto-container">
          <h1>AIGC智慧大脑</h1>
          <p><a href="/">首页</a>
            <Icon class="arrow" type="ios-arrow-forward" />我们的优势
            <Icon class="arrow" type="ios-arrow-forward" />AIGC智慧大脑
          </p>
        </div>
      </div>
      <div class="auto-container">
        <section class="rules-section">
          <div class="auto-container">
            <Row>
              <Col :xl="12" :lg="12">
              <div class="inner-column" style="padding: 0">
                <div class="image">
                  <a href="#"><img src="../../assets/resource/sshx.png" alt="" /></a>
                </div>
              </div>
              </Col>
 
              <Col :xl="12" :lg="12">
              <div class="inner-column">
                <div class="sec-title">
                  <div class="title-icon">
                    <span class="icon"><img src="../../assets/icons/separater.png" alt="" /></span>
                  </div>
                  <h2>AIGC智慧大脑</h2>
                </div>
                <div class="text">
                  <p>
                    以教育治理与班级管理痛点为锚点，融合校园全场景数据与教育专属 AI 模型，打造 “数据决策 + 智能服务 + 高效治理” 三位一体的智慧校园核心动力引擎，为学校管理者、班主任、教师提供轻量化、精准化、场景化的智能解决方案。
                    AIGC智慧大脑的三层架构：场景应用层（教学辅助模块、管理决策模块、家校服务模块）、AI能力层（安全治理：AIGC大模型训练中心/多核交互引擎智能决策算法库）、数据基座层（校园全场景数据采集、数据清洗与治理、智能安全治理、隐私安全体系）
                  </p>
                  <!-- <p>平台将一系列业务活动抽象为不同类型的“流程节点”，通过流程编辑器进行连接，可实现业务流程触发、流转、审批、消息推送等操作，
                    免去了代码编写工作，让使用者能够完全专注于校园业务场景，为学校提供智慧灵活的办公OA搭建工具。</p> -->
                </div>
              </div>
              </Col>
            </Row>
          </div>
        </section>

        <Row style="padding-bottom:80px">
          <Col :xl="8" :lg="8" :md="12" :sm="24" v-for="(item, index) in feature" :key="index">
          <div class="feature-block-two">
            <div class="inner-box ">
              <div class="icon-box">
                <img :src="item.numberPic" alt="" />
              </div>
              <h3>{{ item.title }}</h3>
              <div class="text">{{ item.text }}</div>
            </div>
          </div>
          </Col>
        </Row>

        <!-- <div class="sec-title">
          <div class="title-icon">
            <span class="icon"><img src="../../assets/icons/separater.png" alt="" /></span>
          </div>
          <h2>图集</h2>
        </div>
        <Carousel v-model="value" loop autoplay dots="none" arrow="always" autoplay-speed="5000">
          <CarouselItem>
            <div class="picBox">
              <img class="pic" src="../../assets/pic/sshx1.png" alt="" srcset="">
            </div>
          </CarouselItem>
          <CarouselItem>
            <div class="picBox">
              <img class="pic" src="../../assets/pic/sshx2.png" alt="" srcset="">
            </div>
          </CarouselItem>
          <CarouselItem>
            <div class="picBox">
              <img class="pic" src="../../assets/pic/sshx3.png" alt="" srcset="">
            </div>
          </CarouselItem>
          <CarouselItem>
            <div class="picBox">
              <img class="pic" src="../../assets/pic/sshx4.png" alt="" srcset="">
            </div>
          </CarouselItem>
          <CarouselItem>
            <div class="picBox">
              <img class="pic" src="../../assets/pic/sshx5.png" alt="" srcset="">
            </div>
          </CarouselItem>
          <CarouselItem>
            <div class="picBox">
              <img class="pic" src="../../assets/pic/sshx6.png" alt="" srcset="">
            </div>
          </CarouselItem>
        </Carousel> -->
      </div>
    </div>
  </div>
</template>
<script>
import aigc from "./aigc.js";
export default aigc;
</script>

<style lang="less" scoped>
@import "./aigc.less";
</style>